var map = {
	"./download_gift1.png": "efbc",
	"./download_gift2.png": "bf7f",
	"./invitation_gift1.png": "e8ad",
	"./invitation_gift2.png": "8825",
	"./invitation_gift3.png": "3c14",
	"./reservation_gift1.png": "cd4c",
	"./reservation_gift2.png": "53db",
	"./reservation_gift3.png": "74db",
	"./reservation_gift4.png": "91b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5172";